import React from "react";

export default function QuestionCompletion({ value, onChange, disabled }) {
    return (
        <input
            className="qr-text-input"
            type="text"
            value={value || ""}
            onChange={(event) => onChange(event.target.value)}
            disabled={disabled}
            placeholder="Saisissez votre reponse"
        />
    );
}
